/**
 * The Sanity header keeps its single `logo` image and adds `brandLogos`, a list of
 * images that can each set `userRoles`. An image without roles uses the header's own
 * `userRoles`. The first brand logo the logged-in user can see is shown; when there
 * is none, the header falls back to `logo`.
 *
 * Order and shipping emails do not render this tastic. The functions that build
 * those Mailchimp payloads read the same fields and send the chosen URL as the
 * `brandLogo` merge var.
 */

type PermissionCheck = (item: any, customerGroup: any) => boolean;

type BrandLogoFields = {
  logo?: unknown;
  brandLogos?: unknown;
  userRoles?: unknown;
} | null | undefined;

export function sanityAssetUrl(image: unknown): string {
  if (!image || typeof image !== 'object') {
    return typeof image === 'string' ? image : '';
  }

  const asset = image as { fields?: { file?: { url?: string } }; url?: string };
  return asset.fields?.file?.url || asset.url || '';
}

function itemRoles(item: unknown): unknown[] | undefined {
  if (!item || typeof item !== 'object') return undefined;
  const roles = (item as { userRoles?: unknown }).userRoles;
  return Array.isArray(roles) ? roles : undefined;
}

function withEffectiveRoles(item: unknown, parentRoles: unknown[]) {
  const own = itemRoles(item);
  if (own && own.length > 0) return item;
  return { ...(item as object), userRoles: parentRoles };
}

export function resolveBrandLogoUrl(
  fields: BrandLogoFields,
  customerGroup: { obj?: { key?: string } } | null | undefined,
  checkItemPermission: PermissionCheck,
): string {
  const brandLogos = Array.isArray(fields?.brandLogos) ? fields.brandLogos : [];
  const parentRoles = itemRoles(fields) ?? [];
  const chosen = brandLogos.find((item) =>
    checkItemPermission(withEffectiveRoles(item, parentRoles), customerGroup),
  );

  return sanityAssetUrl(chosen) || sanityAssetUrl(fields?.logo);
}
